import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'reactstrap'

const PathogenSymptoms = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding5rem1 right-padding5rem1 py-md-5 py-4 bg-img' style={{ backgroundImage:'url("pathogen-testing/ULC-Testing-bg-v1.png")'}}>
            <div className='py-md-4 py-2'>
                <div className='fs-ss-30-2 text-montserrat text-ss-primary fw-700 lh-1-2 pb-2'>
                    Signs and Symptoms of a Respiratory Infection
                </div>
                <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
            </div>

            <div className='pb-4'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                Coughing, difficulty breathing, sore throat, stuffy or runny nose, fatigue, and loss of appetite are all fever symptoms. When called to action our team can collect a sample for RPP testing in one of two ways:
                </div>
            </div>

            <div className='pb-2'>
                <div className='fs-ss-22-2 text-montserrat fw-700 text-ss-secondary lh-1-2' style={{ letterSpacing:'0.5px'}}>
                    A Swab Of The Nasopharynx For RPP
                </div>
            </div>

            <div className='pb-3'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                You will tip your head back. In RPP swab test healthcare provider will insert a cotton swab strip into your nostril until it reaches the upper part of your throat. After specimen collection, the cotton swab strip will be rotated and removed gently.
                </div>
            </div>

            <div className='pb-2'>
                <div className='fs-ss-22-2 text-montserrat fw-700 text-ss-secondary' style={{ letterSpacing:'0.5px'}}>
                    Nasal Aspirate
                </div>
            </div>

            <div className='pb-4'>
                <div className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                After injecting a saline solution into your nose, our professional staff member will use gentle suction to remove the sample.
                </div>
            </div>

            <div className=''>
            <center>
            <Link to='/book-panel-test-appointment'>
                <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                    <text className='text-montserrat fw-600 fs-ss-16-1' style={{ padding:'',}}>
                        SCHEDULE YOUR TEST
                    </text>
                </Button>
                </Link>
            </center>
            </div>
        </div>
    </div>
  )
}

export default PathogenSymptoms